import type { TypedUseQuerySubscriptionOptions } from '@reduxjs/toolkit/query/react';
import StructureAPI from '../StructureAPI';

type Options = TypedUseQuerySubscriptionOptions;
function useStructuresWorkspace(workspaceId?: string, options?: Options) {
  return StructureAPI.endpoints.getStructureV2.useQuery(workspaceId, options);
}

export default useStructuresWorkspace;
